import { useMemo, useRef } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import { GetSingleSession } from "../../../../../connection/sessions";
import { loadWorkingSession } from "../../../../../store/actions/admin/create-event/session";
import { useTypedSelector } from "../../../../../store/reducers/use-typed-selector";

import { Session } from "../../../../../types/working-model";
import { switchingLanguageAlert } from "../../homepage/editor/header/header";

interface ISessionEditorHeaderProps {
	session: Session;
	setIsLoading: (isLoading: boolean) => void
}

const SessionEditorHeader: React.FC<ISessionEditorHeaderProps> = ({ session, setIsLoading }) => {
	const {
		AuthReducer: {
			token
		}
	} = useTypedSelector((state) => state);
	const languagesContainerRef = useRef<HTMLDivElement | null>(null);

	const dispatch = useDispatch();
	const history = useHistory();
	const params = useParams<any>();

	const languages = session.languages;

	const handleLanguageClick = (language: string) => async () => {
		if (params.id && params.session) {
			setIsLoading(true);
			switchingLanguageAlert();

			const _session = await GetSingleSession(token!, session.session);

			if (_session) {
				dispatch(loadWorkingSession(_session));
			}

			history.replace(`/admin/events/create/${params.id}/session/${params.session}/${language}`);
			setIsLoading(false);
		}
	};

	const sortedLanguages = useMemo(() => {
		return [session.default_language, ...languages.filter((lang: string) => lang !== session.default_language).sort()];
	}, [languages, session.default_language]);

	return (
		<div className="session-editor-header">
			{languages?.length >= 1 ? (
				<div className="session-editor-header-column session-editor-header-languages">
					<h6 className="session-editor-header-titles">Language</h6>
					<div ref={languagesContainerRef} className="session-editor-langauges-container">
						{sortedLanguages.map((language: string, index: number) => {
							if (index < 11) {
								return (
									<div key={language} className="session-editor-langauge-item">
										<button
											className={params?.language === language ? 'active' : ''}
											onClick={handleLanguageClick(language)}
										>
											{language}
										</button>
									</div>
								);
							}
						})}
						{languages.length >= 11 && (
							<div className="session-editor-langauge-item">
								<button>
									+{languages.length - 10}
								</button>
							</div>
						)}
					</div>
				</div>
			) : null}
		</div>
	);
};

export default SessionEditorHeader;
